import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { useUserContext } from "../hooks/useUserContext";
import { toast } from "react-toastify";
import { disableTwoFa } from "../api/v2/requests";
import { Button, buttonVariants } from "~/atoms/button";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
  AlertDialogTrigger,
} from "~/atoms/alert-dialog";
import { OverlaySpinner } from "../atoms/spinner";

export function TwoFactorAuthSettings() {
  const { t } = useTranslation();
  const { user, setUser } = useUserContext();
  const [isLoading, setIsLoading] = useState(false);

  const handleDisableTwoFa = async () => {
    try {
      setIsLoading(true);
      await disableTwoFa();
      setUser({ ...user, isTwoFaEnabled: false });
      toast.success(t(($) => $.toasts.success["2faDisabled"]));
    } catch {
      toast.error(t(($) => $.toasts.error.generic));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="grid">
      {isLoading && <OverlaySpinner />}
      <p className="text-lg font-medium">{t(($) => $.settings["2fa"].title)}</p>
      <p className="text-muted-foreground text-sm">
        {user.isTwoFaEnabled
          ? t(($) => $.settings["2fa"].description2FaOn)
          : t(($) => $.settings["2fa"].description2FaOff)}
      </p>
      <div className="pt-4">
        {user.isTwoFaEnabled ? (
          <AlertDialog>
            <AlertDialogTrigger asChild>
              <Button variant="destructive" className="flex justify-self-end">
                {t(($) => $.settings["2fa"].buttons.disable)}
              </Button>
            </AlertDialogTrigger>
            <AlertDialogContent>
              <AlertDialogHeader>
                <AlertDialogTitle>
                  {t(($) => $.settings["2fa"].disableTitle)}
                </AlertDialogTitle>
                <AlertDialogDescription>
                  {t(($) => $.settings["2fa"].disableDesc)}
                </AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter>
                <AlertDialogCancel>
                  {t(($) => $.commons.buttons.cancel)}
                </AlertDialogCancel>
                <AlertDialogAction
                  className={buttonVariants({ variant: "destructive" })}
                  onClick={handleDisableTwoFa}
                >
                  {t(($) => $.settings["2fa"].buttons.yesDisable)}
                </AlertDialogAction>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>
        ) : (
          <Button asChild className="flex justify-self-end">
            <Link to="/set-up-2fa">
              {t(($) => $.settings["2fa"].buttons.setUp)}
            </Link>
          </Button>
        )}
      </div>
    </div>
  );
}
